'use client'
import { INTERNAL_DATA } from '@/config/global-config'
import { useSettingsContext } from '@/contexts/settings/provider'
import { Box, BoxProps } from '@mui/material'
import Image from 'next/image'
import Link from '@/features/ref/components/Link'
type LogoProps = {
  href?: string
  props?: Omit<BoxProps, 'children'>
}
export const Logo = ({ href, props }: LogoProps) => {
  const { values } = useSettingsContext()

  return (
    <Box {...props} sx={{ flex: '0 0 auto', height: { md: 64, xs: 44 }, width: 'auto', ...props?.sx }}>
      <Link href={href || '/'}>
        <Image
          src={INTERNAL_DATA.logo}
          width={122}
          height={64}
          sizes="(max-width: 768px) 100vw, 30vw"
          alt="Logo"
          style={{
            height: '100%',
            width: 'auto',
            filter: values.mode === 'dark' ? 'invert(1)' : 'none',
            transition: 'filter 0.3s ease',
            pointerEvents: 'none',
          }}
        />
      </Link>
    </Box>
  )
}
